import { get } from 'lodash';

// service
import ubisoftOverlayService from '../ubisoft-overlay-service';

// types
import { IGetUserStatusResponse, ITriggerEmailActivationResponse } from 'modules/ubisoft-connect-service/types';

interface IEmailVerificationService {
    isEmailVerified: () => Promise<boolean>;
    triggerEmailActivation: () => Promise<boolean>;
}

class EmailVerificationService implements IEmailVerificationService {
    private VERIFIED_EMAIL_STATUS: string = 'activated';
    private TRIGGERED_EMAIL_ACTIVATION_STATUS: string = 'OK';

    public isEmailVerified(): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            return ubisoftOverlayService.getUserStatus((response: IGetUserStatusResponse) => {
                const status: string = get(response, 'payload.status.generalStatus');

                return resolve(status === this.VERIFIED_EMAIL_STATUS);
            });
        });
    }

    public triggerEmailActivation(): Promise<boolean> {
        return new Promise<boolean>(resolve => {
            return ubisoftOverlayService.triggerEmailActivation((response: ITriggerEmailActivationResponse) => {
                const isEmailActivationTriggered = get(response, 'status') === this.TRIGGERED_EMAIL_ACTIVATION_STATUS;
                return resolve(isEmailActivationTriggered);
            });
        });
    }
}

export const emailVerificationService = new EmailVerificationService();

export default emailVerificationService;
